import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import { QuestionFormValues } from '@/utils/forms/questionTransformers';

export function TiebreakerOptionsClearer() {
  const { values, setFieldValue } = useFormikContext<QuestionFormValues>();
  const prevQuestionTypeRef = useRef(values.question_type);

  useEffect(() => {
    const currentType = values.question_type;
    const prevType = prevQuestionTypeRef.current;

    if (currentType === 'tiebreaker' && prevType !== 'tiebreaker' && values.options.length > 0) {
      setFieldValue('options', []);
    }

    prevQuestionTypeRef.current = currentType;
  }, [values.question_type, values.options.length, setFieldValue]);

  return null;
}
